module.exports = __webpack_public_path__ + "static/media/decimal-addition.03c64b29.svg";